import React, { useEffect } from 'react';
import { CollapseBlock, Spinner } from '../../../../common';
import SlidersTable from './SlidersTable.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { SortAscendingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  useDeleteSliderMutation,
  useGetSlidersWithEditQuery,
} from '../../../../../redux/services/sliders';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

const SlidersPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = t('Banery') + ' - FRI CMS';
  }, []); // Runs on mount

  const { data: sliders, isLoading, refetch } = useGetSlidersWithEditQuery();

  const [deleteSlider, { isSuccess: isDeleteSuccess }] =
    useDeleteSliderMutation();

  const { deleteSuccess: showDeleteSuccess } = useToastMessages();

  useEffect(() => {
    if (isDeleteSuccess) {
      showDeleteSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Banery')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Pridať baner')}
        createUrl={routes.cmsSliderCreate}
        permissionsBasic={'sliders'}
        mainActions={[
          {
            onClick: () => navigate(routes.cmsSliderOrder),
            title: t('Zoradiť banery'),
            icon: <SortAscendingOutlined />,
            premision: 'sliders.update',
          },
        ]}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <SlidersTable
            sliders={sliders}
            onDelete={(record) => deleteSlider(record.id)}
            onDetailClick={(record) =>
              navigate(`${routes.cmsSliderEdit}/${record.id}`)
            }
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default SlidersPage;
